import { ChevronLeftIcon } from '@approvalmax/ui';
import { Button, Form, Grid } from '@approvalmax/ui/src/components';
import { TermsAndPolicy } from 'shared/components/(wallets)/kyc/TermsAndPolicy';

import { wizardStepComponentsMap } from './Wizard.constants';
import { useWizardForm, useWizardRouting } from './Wizard.hooks';
import { messages } from './Wizard.messages';

export const Wizard = () => {
    const { step, moveBack, moveForward, isFirstStep, isLastStep, isSingleStep } = useWizardRouting();

    const Step = wizardStepComponentsMap[step];

    const { isLoading, ...formProps } = useWizardForm(step, moveForward);

    return (
        <Form {...formProps}>
            <Grid gap={24}>
                <Step />

                <Grid
                    gap={16}
                    justifyContent='end'
                    gridAutoFlow='column'
                    gridTemplateColumns={isSingleStep ? '1fr' : isLastStep ? 'max-content 1fr' : undefined}
                >
                    {!isFirstStep && (
                        <Button
                            color='midnight40'
                            disabled={isFirstStep}
                            startIcon={<ChevronLeftIcon />}
                            onClick={moveBack}
                            variant='outline'
                        >
                            {messages.back}
                        </Button>
                    )}

                    <Button color='blue80' type='submit' progress={isLoading}>
                        {isLastStep ? messages.submit : messages.next}
                    </Button>
                </Grid>

                {isLastStep && <TermsAndPolicy actionName={messages.submit} />}
            </Grid>
        </Form>
    );
};

Wizard.displayName = 'Wizard';
